export const PUBLIC_ID_PROPERTY = "Procore/InstanceId";
export const PUBLIC_ID_LEGACY_PROPERTY = "Procore/Id";

/** For comparing against a caller's property name, which `PropertyQuery` matches case-insensitively. */
export const PUBLIC_ID_PROPERTY_LOWERCASE = PUBLIC_ID_PROPERTY.toLowerCase();
